<option *ngFor='let option of likeBooleanHelperDNI' [value]="option"> {{ option }} </option> 